import React from 'react';
import { Modal } from 'porosys-ui';
import './styles.scss';

const customConfirmation = props => {
    const { isOpen, onClose, onClickOk, operationTitle } = props;
    return (
        <>
            {isOpen && (
                <Modal
                    classes={{ root: 'modal' }}
                    onClickOk={onClickOk}
                    okText={operationTitle}
                    title={`آیا از ${operationTitle} اطمینان دارید؟`}
                    onClose={() => {
                        onClose();
                    }}
                    open={true}
                >
                    <p>شما در حال {operationTitle} میباشید!</p>
                </Modal>
            )}
        </>
    );
};

export default customConfirmation;
